import React, { Component, Fragment } from 'react'

import {
    SimpleText,
    Steps
} from './'

class Subsections extends Component {
    renderSubSections(section, key) {
        switch (section.type) {
            case 'SIMPLE_TEXT': 
                return <SimpleText key={key} content={section.content} />
            case 'STEPS':
                return <Steps key={key} steps={section.steps} />
            case 'TABLE':
                return (
                    <table key={key} className="table table-striped">
                        <tbody>
                            {
                                section.data.map((row, keyR) => {
                                    return (
                                        <tr key={keyR}>
                                            {
                                                row.cols.map((col, keyC) => {
                                                    return <td key={keyC}>{col}</td>
                                                })
                                            }
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                )
            case 'INFO_TEXT':
                return <div key={key} dangerouslySetInnerHTML={{ __html: section.content.text }} className="col-lg-12 text-muted text-center" />
            case 'TEXT':
                return (
                    <div key={key} className="text-center">
                        {section.content.title && <h5>{section.content.title}</h5>}
                        <div dangerouslySetInnerHTML={{ __html: section.content.text }} />
                    </div>
                )
            default:
                return null    
        }
    }

    render() {
        return (
            <Fragment>
                { this.props.subsections.map((section, key) => this.renderSubSections(section, key)) }
            </Fragment>
        )
    }
}

export { Subsections }


// WEBPACK FOOTER //
// ./src/components/sections/_SubSections.js